import React from 'react';
import { ShieldCheck, BadgeCheck, Award, Building2 } from 'lucide-react';

// Partners: Each has an optional `logo` URL. If logo is empty, falls back to icon + text.
// Upload official logo image files via chat to populate the `logo` URLs.
const partners = [
  {
    name: 'Colorbond',
    subtitle: 'Steel',
    logo: 'https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/0lrbidjn_colorbond.png',
    Icon: ShieldCheck,
  },
  {
    name: 'BlueScope',
    subtitle: 'Authorised',
    logo: 'https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/n8658fa2_bluescope.png',
    Icon: BadgeCheck,
  },
  {
    name: 'WorkSafe',
    subtitle: 'Victoria',
    logo: 'https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/m8gyz4p5_workcover-logo.png',
    Icon: Award,
  },
  {
    name: 'BPC',
    subtitle: 'Licensed',
    logo: 'https://customer-assets.emergentagent.com/job_plumb-roofing-expert/artifacts/kqi7s2ni_bpc.png',
    Icon: Building2,
  },
];

const PartnerBadge = ({ name, subtitle, logo, Icon }) => {
  if (logo) {
    return (
      <div className="flex flex-col items-center justify-center text-center group">
        <img
          src={logo}
          alt={`${name} ${subtitle}`}
          className="h-20 md:h-24 w-auto max-w-[180px] object-contain hover:scale-105 transition-transform duration-300"
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center text-center group">
      <div className="flex items-center gap-2.5 text-slate-700 group-hover:text-blue-600 transition-colors duration-300">
        {Icon && <Icon size={28} className="text-blue-600/80 group-hover:text-blue-600 transition-colors" />}
        <div className="text-left">
          <div className="font-bold text-lg tracking-tight leading-tight">{name}</div>
          <div className="text-xs text-slate-500 uppercase tracking-wider leading-tight">{subtitle}</div>
        </div>
      </div>
    </div>
  );
};

const IndustryPartners = () => {
  return (
    <section className="py-16 bg-white border-t border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="inline-block text-blue-600 font-semibold text-sm uppercase tracking-wider mb-2">
            Trusted Materials & Standards
          </span>
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900">
            Industry <span className="text-red-600">Partners</span>
          </h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 items-center justify-items-center">
          {partners.map((partner) => (
            <PartnerBadge
              key={partner.name}
              name={partner.name}
              subtitle={partner.subtitle}
              logo={partner.logo}
              Icon={partner.Icon}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryPartners;
